export default __webpack_public_path__ + "Ubisoft_logo.png";